import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import * as SidePanelTags from './side-panel.tagnames';

@customElement(SidePanelTags.SidePanelHeaderTitle)
export class AtlSidePanelHeaderTitle extends LitElement {
   static styles = [
      css`
         :host {
            display: block;
         }

         h2 {
            margin: 0;
            font-family: 'Open Sans Semibold', arial, helvetica, sans-serif;
            font-size: 1rem;
            color: var(--tti-sidepanel-title-color);
         }
      `,
   ];

   render() {
      return html`<h2><slot></slot></h2>`;
   }
}
